"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageColorMode = exports.PageBrandingOption = exports.PageStatus = exports.PagesCnameStatus = exports.PagesSizeUnit = void 0;
var PagesSizeUnit;
(function (PagesSizeUnit) {
  PagesSizeUnit["PERCENT"] = "%";
  PagesSizeUnit["PIXELS"] = "px";
})(PagesSizeUnit = exports.PagesSizeUnit || (exports.PagesSizeUnit = {}));
var PagesCnameStatus;
(function (PagesCnameStatus) {
  PagesCnameStatus["NEEDS_VERIFICATION"] = "NEEDS_VERIFICATION";
  PagesCnameStatus["ENABLED"] = "ENABLED";
  PagesCnameStatus["FAILED"] = "FAILED";
})(PagesCnameStatus = exports.PagesCnameStatus || (exports.PagesCnameStatus = {}));
var PageStatus;
(function (PageStatus) {
  PageStatus["ENABLED"] = "ENABLED";
  PageStatus["DISABLED"] = "DISABLED";
})(PageStatus = exports.PageStatus || (exports.PageStatus = {}));
var PageBrandingOption;
(function (PageBrandingOption) {
  PageBrandingOption["LOGO"] = "LOGO";
  PageBrandingOption["NONE"] = "NONE";
  PageBrandingOption["CUSTOM"] = "CUSTOM";
  PageBrandingOption["ABSOLUTELY_NO_BRANDING"] = "ABSOLUTELY_NO_BRANDING";
})(PageBrandingOption = exports.PageBrandingOption || (exports.PageBrandingOption = {}));
var PageColorMode;
(function (PageColorMode) {
  PageColorMode["LIGHT"] = "LIGHT";
  PageColorMode["DARK"] = "DARK";
})(PageColorMode = exports.PageColorMode || (exports.PageColorMode = {}));